import React from 'react';
import { useTranslation } from "react-i18next";

const DiscoverySectionTitle = () => {
    const { t } = useTranslation();
    
    return (
        <div className="discoverySectionTitle__container">
            <div className="discoverySectionTitle__container-wrap">
                <div className="discoverySectionTitle__container-title-wrap">
                    <div className="discoverySectionTitle__container-title-text">
                        <span>{t('main.discoverYourNextMealHere')}</span>
                    </div>
                </div>
                <div className="discoverySectionTitle__container-subtitle-wrap">
                    <div className="discoverySectionTitle__container-subtitle-text">
                        <span>{t('main.exploreTheBestRestaurants')}</span>
                    </div>
                </div>
                {/*<div className="discoverySectionTitle__container-popular-offers-wrap">
                    <div className="discoverySectionTitle__container-popular-offers-text">
                        <span>here are some of our most popular offers</span>
                    </div>
                </div>*/}
            </div>
        </div>
    );
};

export default DiscoverySectionTitle;